import { render, staticRenderFns } from "./Cryptid.vue?vue&type=template&id=6a603bf6&scoped=true&"
import script from "./Cryptid.vue?vue&type=script&lang=js&"
export * from "./Cryptid.vue?vue&type=script&lang=js&"
import style1 from "./Cryptid.vue?vue&type=style&index=1&id=6a603bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a603bf6",
  null
  
)

/* custom blocks */
import block0 from "./Cryptid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports